var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Box, Chip, Stack, Typography, useMediaQuery } from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid-premium';
import { DynamicCatalogBuilder } from '../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder';
import { MuiStack } from '../../../components';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { useAppDispatch } from '../../../store/hooks';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { dateFormate } from '../../../utils/utils';
import { ContractSaleOrderPagingAPI } from '../services/apiCall';
import { ContractSaleOrderKeys } from '../services/entity';
import { ContractSaleOrderCancelPopup } from './ContractSaleOrderCancelPopup';
import { ReactComponent as EditIcon } from '../../../assets/images/edit-icon.svg';
import { ReactComponent as FileIcon } from '../../../assets/images/FileIconNew.svg';
import { ReactComponent as PrintIcon } from '../../../assets/images/printIcon.svg';
import { ReactComponent as ShearIcon } from '../../../assets/images/shearIcon.svg';
import { ReactComponent as ViewIcon } from '../../../assets/images/viewIcon.svg';
import { showSurface } from '../../../redux/awaitedSurfacesSlice';
import { CancelIconSVG } from '../../spareParts/purchaseRequistion/assets/customIcons';
import { useNavigate } from 'react-router-dom';
var ContractSaleOrderOpentab = function (props) {
    var _getLocalStorageItem, _getLocalStorageItem2;
    var value = props.value;
    var isDesktop = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var userOrganizationID = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var parentOrganizationId = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.ParentOrganizationId;
    var storedMenuFeatures = getLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_FEATURE);
    var dispatch = useAppDispatch();
    var navigate = useNavigate();
    var customActionColumns = [{
            field: 'OrderNumber',
            headerName: 'Order no.',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.OrderNumber ? "".concat(row === null || row === void 0 ? void 0 : row.OrderNumber) : '-'; },
            minWidth: 170
        }, {
            field: 'OrderDate',
            headerName: 'Order date',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.OrderDate ? "".concat(dateFormate(row === null || row === void 0 ? void 0 : row.OrderDate)) : '-'; },
            minWidth: 150
        }, {
            field: 'CustomerName',
            headerName: 'Customer name',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.CustomerName ? "".concat(row === null || row === void 0 ? void 0 : row.CustomerName) : '-'; },
            minWidth: 200
        }, {
            field: 'MobileNumber',
            headerName: 'Customer no.',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.MobileNumber ? "".concat(row === null || row === void 0 ? void 0 : row.MobileNumber) : '-'; },
            minWidth: 200
        }, {
            field: 'ExecutiveName',
            headerName: 'Executive name',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.ExecutiveName ? "".concat(row === null || row === void 0 ? void 0 : row.ExecutiveName) : '-'; },
            minWidth: 200
        }, {
            field: 'ValidTillDateTime',
            headerName: 'Valid till',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.ValidTillDateTime ? "".concat(dateFormate(row === null || row === void 0 ? void 0 : row.ValidTillDateTime)) : '-'; },
            minWidth: 150
        }, {
            field: 'OrderAmount',
            headerName: 'Order Amount',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.OrderAmount ? "".concat(row === null || row === void 0 ? void 0 : row.OrderAmount) : '-'; },
            minWidth: 150
        }, {
            field: 'StatusName',
            headerName: 'Status',
            renderCell: function (params) {
                var _params$row, _params$row$StatusNam, _params$row2, _params$row3;
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    alignItems: 'center',
                    height: '100%'
                }, params !== null && params !== void 0 && (_params$row = params.row) !== null && _params$row !== void 0 && _params$row.StatusName ? /*#__PURE__*/ React.createElement(Chip, {
                    label: (_params$row$StatusNam = params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.StatusName) !== null && _params$row$StatusNam !== void 0 ? _params$row$StatusNam : '-',
                    size: "small",
                    variant: "outlined",
                    id: 'status',
                    sx: {
                        borderRadius: 2,
                        px: 1,
                        fontWeight: 500,
                        fontSize: 12,
                        color: 'black'
                    },
                    icon: (params === null || params === void 0 || (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.StatusName) == 'Cancelled' ? /*#__PURE__*/ React.createElement(Box, {
                        height: 8,
                        width: 8,
                        borderRadius: 10,
                        bgcolor: "red"
                    }) : undefined
                }) : /*#__PURE__*/ React.createElement(Typography, null, '-'));
            },
            minWidth: 150
        }, {
            type: 'actions',
            field: 'actions',
            headerName: '',
            getActions: function (params) {
                var _this = this;
                var getIcon = function (name) {
                    switch (name) {
                        case 'GenerateInvoice':
                            return /*#__PURE__*/ React.createElement(FileIcon, {
                                height: 16,
                                width: 16,
                                color: "secondary.500"
                            });
                        case 'ViewOrder':
                            return /*#__PURE__*/ React.createElement(ViewIcon, {
                                height: 16,
                                width: 16
                            });
                        case 'Edit Order':
                            return /*#__PURE__*/ React.createElement(EditIcon, {
                                height: 16,
                                width: 16
                            });
                        case 'CancelOrder':
                            return /*#__PURE__*/ React.createElement(CancelIconSVG, {
                                height: 16,
                                width: 16
                            });
                        case 'ShareOrder':
                            return /*#__PURE__*/ React.createElement(ShearIcon, {
                                height: 16,
                                width: 16
                            });
                        case 'PrintOrder':
                            return /*#__PURE__*/ React.createElement(PrintIcon, {
                                height: 16,
                                width: 16
                            });
                        default:
                            return /*#__PURE__*/ React.createElement(React.Fragment, null);
                    }
                };
                return storedMenuFeatures === null || storedMenuFeatures === void 0 ? void 0 : storedMenuFeatures.map(function (data) { /*#__PURE__*/ return React.createElement(GridActionsCellItem, {
                    label: data.DisplayName,
                    icon: getIcon(data === null || data === void 0 ? void 0 : data.Name),
                    showInMenu: true,
                    onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                        var _params$row4, _params$row5, result, _params$row6;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    console.log('data111', data);
                                    if (!((data === null || data === void 0 ? void 0 : data.Name) == "Edit Order")) return [3 /*break*/, 1];
                                    console.log('edit click');
                                    handleRowEditClick(params === null || params === void 0 || (_params$row4 = params.row) === null || _params$row4 === void 0 ? void 0 : _params$row4.id);
                                    return [3 /*break*/, 4];
                                case 1:
                                    if (!((data === null || data === void 0 ? void 0 : data.Name) === "CancelOrder")) return [3 /*break*/, 3];
                                    console.log('cancel click');
                                    return [4 /*yield*/, dispatch(showSurface({
                                            type: 'Dialog',
                                            containerProps: {
                                                PaperProps: {
                                                    sx: {
                                                        width: {
                                                            xs: "200px",
                                                            md: '400px',
                                                            lg: '400px'
                                                        }
                                                    }
                                                }
                                            },
                                            Component: ContractSaleOrderCancelPopup,
                                            componentProps: {
                                                id: params === null || params === void 0 || (_params$row5 = params.row) === null || _params$row5 === void 0 ? void 0 : _params$row5.id
                                            }
                                        }))];
                                case 2:
                                    result = _a.sent();
                                    return [3 /*break*/, 4];
                                case 3:
                                    if ((data === null || data === void 0 ? void 0 : data.Name) === "GenerateInvoice") {
                                        navigate("/createContractSaleInvoice/".concat(params === null || params === void 0 || (_params$row6 = params.row) === null || _params$row6 === void 0 ? void 0 : _params$row6.id, "?mode=edit"));
                                    }
                                    _a.label = 4;
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); }
                }); });
            }
        }];
    var handleRowEditClick = function (id) {
        navigate("/createContractSaleOrder/".concat(id, "?mode=edit"));
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Stack, {
        p: 2
    }, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        pagingAPIKey: ContractSaleOrderKeys.Paging,
        getPagingData: ContractSaleOrderPagingAPI,
        pagingAPIRequest: _objectSpread({
            Status: ['Open'],
            OrganizationId: userOrganizationID,
            ParentOrganizationId: parentOrganizationId,
            IdentityId: (value === null || value === void 0 ? void 0 : value.IdentityId) == "all" ? null : value === null || value === void 0 ? void 0 : value.IdentityId,
            search: value === null || value === void 0 ? void 0 : value.search
        }, value === null || value === void 0 ? void 0 : value.Filters),
        columns: customActionColumns,
        dataGridProps: {
            // onCellClick: (params) => {
            //     if (!(params.field === 'actions')) {
            //         handleRowClick(params?.id)
            //     }
            // },
            disableColumnMenu: false,
            initialState: {
                pinnedColumns: {
                    right: ['actions']
                }
            }
        }
    })));
};
export default ContractSaleOrderOpentab;
